import React from "react";
import "../styling/MunicipalityText.css";

const Uppsala = () => {
  return (
    <div className="outer-wrapper">
      <div className="content-wrapper">
        <h2 className="content-title">Lediga lokaler i Uppsala</h2>
        <p className="content-text">
          Uppsala är Sveriges fjärde största stad – en universitets- och
          kunskapsstad med starka kluster inom life science, tech, vård och
          offentlig service. Här kombineras historisk stadskärna och raka
          huvudstråk med smidig pendling till Stockholm och Arlanda. På Vakansa
          hittar du kontor, kontorshotell/coworking, lager, teater och
          speciallokaler – och vi hjälper dig att snabbt jämföra alternativ och
          boka visning.
        </p>
        <h3>Varför hyra lokal i Uppsala?</h3>
        <ul className="content-ol">
          <li>
            <b>Talang & lärosäten:</b> Uppsala universitet och SLU skapar ett
            stabilt inflöde av kompetens.
          </li>
          <li>
            <b>Läget:</b> Snabba förbindelser via E4, Ostkustbanan, Uppsala C
            och närhet till Arlanda.
          </li>
          <li>
            <b>Starka kluster:</b> Life science kring Uppsala Science Park,
            handel i Boländerna/Gränbystaden, kontor/servicenäring i centrum.
          </li>
          <li>
            <b>Skalbarhet:</b> Från flexplats till egna våningsplan – väx utan
            att byta stad.
          </li>
        </ul>
        <h3>Populära områden</h3>
        <ul>
          <li>
            <b>Centrum/Kungsängen:</b>
            Representativa kontor, närhet till station, restauranger och
            service.
          </li>
          <li>
            <b>Boländerna:</b> Handel, logistik och lätt industri – god
            framkomlighet och parkering.
          </li>
          <li>
            <b>Fyrislund:</b> Företagspark med starkt inslag av industri/teknik
            och goda kommunikationer.
          </li>
          <li>
            <b>Gränbystaden:</b> Handel och service i expansivt läge.
          </li>
          <li>
            <b>Luthagen/Eriksberg m.fl.:</b> Mindre kontor/klinik- och
            serviceytor nära bostadsområden.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Uppsala;
